import { STRAPI_URL } from "../env";

export function getRequestedPdfTabIndex(): number | undefined {
  const value = new URLSearchParams(window.location.search).get(
    "pimoPdfTabIndex"
  );
  if (value === null) return undefined;

  const index = Number(value);
  return Number.isInteger(index) && index >= 0 ? index : undefined;
}

export async function downloadPdf(): Promise<void> {
  const pageUrl = new URL(window.location.href);
  const visibleTabLists = Array.from(
    document.querySelectorAll<HTMLElement>('[role="tablist"]')
  ).filter((tabList) => tabList.getClientRects().length > 0);
  const primaryTabList = visibleTabLists[0];
  const tabs = primaryTabList
    ? Array.from(primaryTabList.querySelectorAll<HTMLElement>('[role="tab"]'))
    : [];
  const activeTabIndex = tabs.findIndex(
    (tab) => tab.getAttribute("aria-selected") === "true"
  );

  if (activeTabIndex >= 0) {
    pageUrl.searchParams.set("pimoPdfTabIndex", String(activeTabIndex));
  }

  let language: string | null = null;
  try {
    language = window.localStorage.getItem("language");
  } catch {
    // Use the app's default language when browser storage is unavailable.
  }

  const response = await fetch(`${STRAPI_URL}/bff-dashboard/pdf`, {
    method: "POST",
    cache: "no-store",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      path: `${pageUrl.pathname}${pageUrl.search}`,
      language,
      timezoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }),
  });

  if (!response.ok) {
    throw new Error(`PDF export failed with status ${response.status}.`);
  }

  const pdf = await response.blob();
  const objectUrl = URL.createObjectURL(pdf);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = "pimo-report.pdf";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
